import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular/main';
import { ICellRendererParams } from 'ag-grid-community/main';

export interface TextListItem {
    text: string;
    tooltip: string;
}

export class TextListParams {

    public items: TextListItem[];

    constructor(items?: TextListItem []) {
        this.items = items ? items : [];
    }

    public toString() {
        return this.items ? this.items.map(i => i.text).join(' ') : '';
    }
}

@Component({
    selector: 'text-list-cell',
    template: require('./text-list-ag-renderer.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class TextListAgRendererComponent implements AgRendererComponent {
    
    public params: TextListParams = new TextListParams();

    public agInit(row: ICellRendererParams): void {

        if (!row.data || !row.value) {
            return;
        }

        this.params = row.value;
    }

    public refresh() {
        return false;
    }
}